<template>
	<div class="info-page">
		<b-container>
			<h1>Preise</h1>
			<PriceTable/>
			<h2 class="mb-1">So funktioniert's:</h2>
			<div>Schneller und einfacher zum passenden Mitarbeiter.</div>
			<HowItWorks class="mt-4"/>
			<CustomerBenefits class="mt-4"/>
			<div class="mt-4 text-center">
				<Button icon="caret-right" text="Passende Mitarbeiter finden!" href="/kunde/eintragung"/>
			</div>
		</b-container>
	</div>
</template>

<script>
import PriceTable from "@/vue/payment/PriceTable.vue";
import HowItWorks from "@/vue/info/HowItWorks.vue";
import CustomerBenefits from "@/vue/info/CustomerBenefits.vue";
import Button from "@/vue/common/Button.vue";

export default {

	components: {
		Button,
		CustomerBenefits,
		HowItWorks,
		PriceTable,
	},
}
</script>
